import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב לבלבול",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה להגדיר מי אני.",
      "אני רק יושב/ת איתי בתוך השאלה.",
      "זה מספיק לרגע הזה."
    ],
      [
      "היום אני לא מנסה להגדיר מי אני.",
      "אני רק יושב/ת איתי בתוך השאלה.",
      "זה מספיק לרגע הזה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני מרגיש/ה הכי לא אני?",
      "מה קרה לפני שהתחלתי להרגיש כך?",
      "איזה חלק בי מבקש הכרה עכשיו?"
    ],
      [
      "מתי אני מרגיש/ה הכי לא אני?",
      "מה קרה לפני שהתחלתי להרגיש כך?",
      "איזה חלק בי מבקש הכרה עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גם בלבול הוא סימן שאני עדיין מחפש/ת אותי."
    ],
      [
      "גם בלבול הוא סימן שאני עדיין מחפש/ת אותי."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד לעצמי — \"אני כאן\".",
      "משפט אחד לעצמי — \"אני כאן\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה השתנה בי",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לשינויים.",
      "בלי לנסות לתקן אותם.",
      "רק לראות."
    ],
      [
      "היום אני שם/ה לב לשינויים.",
      "בלי לנסות לתקן אותם.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הגוף על הכיסא."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הגוף על הכיסא."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה בי השתנה בתקופה הזו?",
      "מה נשאר אותו דבר למרות הכול?",
      "מה מפחיד אותי בשינוי הזה?"
    ],
      [
      "מה בי השתנה בתקופה הזו?",
      "מה נשאר אותו דבר למרות הכול?",
      "מה מפחיד אותי בשינוי הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "שינוי לא מבטל אותי, הוא רק מבלבל."
    ],
      [
      "שינוי לא מבטל אותי, הוא רק מבלבל."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם המילה \"מותר\".",
      "נשימה אחת עם המילה \"מותר\"."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "רגעים שאני כן אני",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת רגעים של אני.",
      "גם אם הם קטנים.",
      "זה מספיק."
    ],
      [
      "היום אני מחפש/ת רגעים של אני.",
      "גם אם הם קטנים.",
      "זה מספיק."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "אני שם/ה לב לנשימה."
    ],
      [
      "אני עוצר/ת רגע.",
      "אני שם/ה לב לנשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי לאחרונה הרגשתי שאני אני?",
      "מה היה שם שאהבתי?",
      "איך זה מרגיש בגוף כשאני אני?"
    ],
      [
      "מתי לאחרונה הרגשתי שאני אני?",
      "מה היה שם שאהבתי?",
      "איך זה מרגיש בגוף כשאני אני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "יש בי נקודות אור, גם אם הן נדירות."
    ],
      [
      "יש בי נקודות אור, גם אם הן נדירות."
    ]
    ),
    action: localizedGenderNode(
      "לזכור רגע אחד כזה.",
      "לזכור רגע אחד כזה."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "תפקידים שנשרו",
    opening: localizedGenderNode(
      [
      "היום אני רואה את התפקידים שכבר לא מחזיקים.",
      "בלי אשמה.",
      "רק אמת."
    ],
      [
      "היום אני רואה את התפקידים שכבר לא מחזיקים.",
      "בלי אשמה.",
      "רק אמת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מניח/ה יד על הלב.",
      "נשימה אחת."
    ],
      [
      "אני מניח/ה יד על הלב.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה תפקיד בי נשמט לאחרונה?",
      "מה היה בו שנתן לי ביטחון?",
      "מה אני מפחד/ת להיות בלעדיו?"
    ],
      [
      "איזה תפקיד בי נשמט לאחרונה?",
      "מה היה בו שנתן לי ביטחון?",
      "מה אני מפחד/ת להיות בלעדיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גם בלי תפקיד, אני עדיין אני."
    ],
      [
      "גם בלי תפקיד, אני עדיין אני."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד של נחמה לעצמי.",
      "משפט אחד של נחמה לעצמי."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "מה אני מנסה להיות",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למה שאני מנסה להחזיק.",
      "לא לשפוט.",
      "רק לראות."
    ],
      [
      "היום אני שם/ה לב למה שאני מנסה להחזיק.",
      "לא לשפוט.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת אל הבטן.",
      "אני כאן."
    ],
      [
      "אני נושם/ת אל הבטן.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מנסה להיות כדי להרגיש בטוח/ה?",
      "למי אני מנסה להתאים?",
      "מה זה עולה לי?"
    ],
      [
      "מה אני מנסה להיות כדי להרגיש בטוח/ה?",
      "למי אני מנסה להתאים?",
      "מה זה עולה לי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להחזיק דמות זה מעייף."
    ],
      [
      "להחזיק דמות זה מעייף."
    ]
    ),
    action: localizedGenderNode(
      "להרפות רגע אחד מהמאמץ.",
      "להרפות רגע אחד מהמאמץ."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "קולות מבחוץ",
    opening: localizedGenderNode(
      [
      "היום אני מזהה מה בא מבחוץ.",
      "ומה נשאר בתוכי.",
      "בלי ויכוח."
    ],
      [
      "היום אני מזהה מה בא מבחוץ.",
      "ומה נשאר בתוכי.",
      "בלי ויכוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "אני שומע/ת את השקט."
    ],
      [
      "אני עוצר/ת רגע.",
      "אני שומע/ת את השקט."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה קול חיצוני הכי שולט בי?",
      "מה הוא אומר לי שאני 'בוחר/ת/ה' להיות?",
      "מה הקול הפנימי שלי אומר במקביל?"
    ],
      [
      "איזה קול חיצוני הכי שולט בי?",
      "מה הוא אומר לי שאני 'בוחר/ת/ה' להיות?",
      "מה הקול הפנימי שלי אומר במקביל?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "יש בי יותר מקול אחד, ואני יכול/ה לבחור למי להקשיב."
    ],
      [
      "יש בי יותר מקול אחד, ואני יכול/ה לבחור למי להקשיב."
    ]
    ),
    action: localizedGenderNode(
      "לתת מקום לקול שקט אחד.",
      "לתת מקום לקול שקט אחד."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "מה חסר לי ממני",
    opening: localizedGenderNode(
      [
      "היום אני פוגש/ת געגוע פנימי.",
      "לא לתקן.",
      "רק להרגיש."
    ],
      [
      "היום אני פוגש/ת געגוע פנימי.",
      "לא לתקן.",
      "רק להרגיש."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה יד על הבטן.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה יד על הבטן.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מתגעגע/ת אליו בי?",
      "מתי היה לי ממנו יותר?",
      "מה היה נותן לו טיפת מקום היום?"
    ],
      [
      "מה אני מתגעגע/ת אליו בי?",
      "מתי היה לי ממנו יותר?",
      "מה היה נותן לו טיפת מקום היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגעגוע הוא גם חוט חיבור."
    ],
      [
      "הגעגוע הוא גם חוט חיבור."
    ]
    ),
    action: localizedGenderNode(
      "להזכיר לעצמי דבר אחד שאני אוהב/ת בי.",
      "להזכיר לעצמי דבר אחד שאני אוהב/ת בי."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "ערכים שקטים",
    opening: localizedGenderNode(
      [
      "היום אני מסתכל/ת על מה שחשוב לי באמת.",
      "לא בקול רם.",
      "בשקט."
    ],
      [
      "היום אני מסתכל/ת על מה שחשוב לי באמת.",
      "לא בקול רם.",
      "בשקט."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני נותן/ת לעצמי רגע."
    ],
      [
      "אני נושם/ת לאט.",
      "אני נותן/ת לעצמי רגע."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה ערך אחד נשאר איתי?",
      "איך הוא נראה ביום פשוט?",
      "מה אני יכול/ה לעשות כדי לכבד אותו היום?"
    ],
      [
      "איזה ערך אחד נשאר איתי?",
      "איך הוא נראה ביום פשוט?",
      "מה אני יכול/ה לעשות כדי לכבד אותו היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ערך אחד יכול להיות חוט של אני."
    ],
      [
      "ערך אחד יכול להיות חוט של אני."
    ]
    ),
    action: localizedGenderNode(
      "מילה אחת שמבטאת את הערך.",
      "מילה אחת שמבטאת את הערך."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "גבול קטן",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת גבול שמגן עליי.",
      "לא כדי להתרחק.",
      "כדי להישאר."
    ],
      [
      "היום אני בודק/ת גבול שמגן עליי.",
      "לא כדי להתרחק.",
      "כדי להישאר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הרגליים על הרצפה."
    ],
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הרגליים על הרצפה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני נוטה לוותר על עצמי?",
      "איזה גבול קטן היה עוזר לי להישאר בי?",
      "איך אני יכול/ה לומר אותו לעצמי קודם?"
    ],
      [
      "איפה אני נוטה לוותר על עצמי?",
      "איזה גבול קטן היה עוזר לי להישאר בי?",
      "איך אני יכול/ה לומר אותו לעצמי קודם?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול קטן הוא שמירה, לא מלחמה."
    ],
      [
      "גבול קטן הוא שמירה, לא מלחמה."
    ]
    ),
    action: localizedGenderNode(
      "משפט גבול אחד לעצמי.",
      "משפט גבול אחד לעצמי."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בחירה קטנה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משהו קטן שמקרב אותי אליי.",
      "בלי דרמה.",
      "צעד קטן."
    ],
      [
      "היום אני בוחר/ת משהו קטן שמקרב אותי אליי.",
      "בלי דרמה.",
      "צעד קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת ושם/ה לב.",
      "אני כאן."
    ],
      [
      "אני נושם/ת ושם/ה לב.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מהי בחירה קטנה שתרגיש אמיתית לי?",
      "מה עוצר אותי מלעשות אותה?",
      "מה יקרה אם אעשה רק 10% ממנה?"
    ],
      [
      "מהי בחירה קטנה שתרגיש אמיתית לי?",
      "מה עוצר אותי מלעשות אותה?",
      "מה יקרה אם אעשה רק 10% ממנה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בחירה קטנה יכולה להזכיר לי מי אני."
    ],
      [
      "בחירה קטנה יכולה להזכיר לי מי אני."
    ]
    ),
    action: localizedGenderNode(
      "צעד אחד של 10%.",
      "צעד אחד של 10%."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "שם חדש לעצמי",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לעצמי תיאור עדין.",
      "לא תווית.",
      "רק מילים טובות."
    ],
      [
      "היום אני נותן/ת לעצמי תיאור עדין.",
      "לא תווית.",
      "רק מילים טובות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את האוויר נכנס ויוצא."
    ],
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את האוויר נכנס ויוצא."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה מילה טובה מתארת אותי היום?",
      "מה אני עושה שמראה את המילה הזו?",
      "איך מרגיש לי לשמוע אותה על עצמי?"
    ],
      [
      "איזה מילה טובה מתארת אותי היום?",
      "מה אני עושה שמראה את המילה הזו?",
      "איך מרגיש לי לשמוע אותה על עצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מילה טובה אחת יכולה להיות עוגן."
    ],
      [
      "מילה טובה אחת יכולה להיות עוגן."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המילה הזו בלב.",
      "לומר את המילה הזו בלב."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "חוטים שמחזיקים",
    opening: localizedGenderNode(
      [
      "היום אני מזהה חוטים שמחזיקים אותי.",
      "אפילו דקים.",
      "הם קיימים."
    ],
      [
      "היום אני מזהה חוטים שמחזיקים אותי.",
      "אפילו דקים.",
      "הם קיימים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הגוף נרגע קצת."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הגוף נרגע קצת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה מחזיק אותי כשאני מתבלבל/ת?",
      "מי או מה מזכיר לי מי אני?",
      "מה אני יכול/ה להחזיק היום?"
    ],
      [
      "מה מחזיק אותי כשאני מתבלבל/ת?",
      "מי או מה מזכיר לי מי אני?",
      "מה אני יכול/ה להחזיק היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "חוט דק אחד מספיק כדי לא לאבד הכול."
    ],
      [
      "חוט דק אחד מספיק כדי לא לאבד הכול."
    ]
    ),
    action: localizedGenderNode(
      "להחזיק משהו קטן שמרגיע אותי.",
      "להחזיק משהו קטן שמרגיע אותי."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "להיות בתהליך",
    opening: localizedGenderNode(
      [
      "היום אני מסכים/ה להיות באמצע.",
      "לא סופי.",
      "לא טעות."
    ],
      [
      "היום אני מסכים/ה להיות באמצע.",
      "לא סופי.",
      "לא טעות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני דורש/ת מעצמי תשובה מיד?",
      "מה יקרה אם אתן לעצמי זמן?",
      "איך נראה יום אחד בלי לחפש תשובה?"
    ],
      [
      "איפה אני דורש/ת מעצמי תשובה מיד?",
      "מה יקרה אם אתן לעצמי זמן?",
      "איך נראה יום אחד בלי לחפש תשובה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להיות באמצע זה מקום אמיתי."
    ],
      [
      "להיות באמצע זה מקום אמיתי."
    ]
    ),
    action: localizedGenderNode(
      "להגיד לעצמי \"מותר לא לדעת\".",
      "להגיד לעצמי \"מותר לא לדעת\"."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משפט שמחזיר אותי.",
      "כשאני הולך/ת לאיבוד.",
      "משפט קטן."
    ],
      [
      "היום אני בוחר/ת משפט שמחזיר אותי.",
      "כשאני הולך/ת לאיבוד.",
      "משפט קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על עצמי במסע הזה?",
      "מה הסימן הראשון שאני מתרחק/ת מעצמי?",
      "איזה משפט קצר מחזיר אותי?"
    ],
      [
      "מה למדתי על עצמי במסע הזה?",
      "מה הסימן הראשון שאני מתרחק/ת מעצמי?",
      "איזה משפט קצר מחזיר אותי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה ללכת לאיבוד ולהחזיר את עצמי בנשימה אחת."
    ],
      [
      "אני יכול/ה ללכת לאיבוד ולהחזיר את עצמי בנשימה אחת."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט החדש פעם אחת.",
      "לומר את המשפט החדש פעם אחת."
    ),
  },
].map(buildNormalizedDay);

export const lossOfSenseOfIdentityWhoAmIEvenTodayBlueprintHe = buildNormalizedPilotBlueprint({
  id: "loss_of_sense_of_identity_who_am_i_even_today_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "loss_of_sense_of_identity_who_am_i_even_today",
  category: "depression_emptiness_meaning",
  journeyName: {
    he: "אובדן תחושת זהות (מי אני בכלל היום)",
    en: "Loss of sense of identity (Who am I even today)",
    es: "Pérdida del sentido de identidad (¿Quién soy yo hoy?)",
  },
  days,
});

export default lossOfSenseOfIdentityWhoAmIEvenTodayBlueprintHe;
